import React, { useEffect, useState } from 'react';

import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

import { redirectLinkByKey } from '@pages/common/Onboarding/const/redirect-link-by-key';
import {
  getOnboardingSetup,
  getOnboardingSetupProcess,
} from '@pages/common/Onboarding/store/onboarding-thunk';
import { RadioButtonBlankIcon, CheckInCircleContainedIcon } from '@setup/svg-icons/svg-icons';
import { AnalyticsEventEnum } from '@shared/enums/analyticsEvent.enum';
import useAnalyticsEventTracker from '@shared/hooks/analytics/useAnalyticsEventTracker';
import { useAppDispatch } from '@shared/hooks/redux';
import { OnboardingItemsSkeleton } from '@shared/ui/popovers/OnboardingPopover/components/OnboardingItemsSkeleton/OnboardingItemsSkeleton';

import type { OnboardingSubItemKey } from '@pages/common/Onboarding/enum/onboarding-sub-item-key';

export const OnboaridngItems = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const gaEventTracker = useAnalyticsEventTracker();

  const [isLoading, setIsLoading] = useState(true);
  const [onboardingSetupData, setOnboardingSetupData] = useState<any | null>(null);

  useEffect(() => {
    dispatch(getOnboardingSetup({}))
      .unwrap()
      .then(async (data) => {
        await dispatch(getOnboardingSetupProcess({}));
        setOnboardingSetupData(data);
        setIsLoading(false);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch]);

  const renderItems = onboardingSetupData?.map((item: any, index: number) => {
    const redirect = redirectLinkByKey[item.item as OnboardingSubItemKey];
    const styleLink = {
      width: '100%',
      textDecoration: item.is_done ? 'line-through ' : 'none',
      pointerEvents: item.is_done ? 'none' : 'auto',
      textDecorationColor: theme.palette.case.neutral.n500,
    } as const;

    return (
      <Link
        key={index}
        to={redirect?.to}
        onClick={() => {
          redirect?.click;
          gaEventTracker({
            event: redirect?.analyticsKey ?? AnalyticsEventEnum.undefinedEvent,
          });
          onClose();
        }}
        style={styleLink}
      >
        <Box display={'flex'} alignItems={'center'}>
          {item.is_done ? (
            <Box
              sx={{
                svg: {
                  width: '16px',
                  height: '16px',
                  path: { fill: theme.palette.case.aquamarine.a700 },
                },
              }}
            >
              <CheckInCircleContainedIcon />
            </Box>
          ) : (
            <Box
              sx={{
                svg: {
                  width: '16px',
                  height: '16px',
                  path: { fill: theme.palette.case.neutral.n500 },
                },
              }}
            >
              <RadioButtonBlankIcon />
            </Box>
          )}

          <Typography
            sx={{
              ml: '8px',
              pt: '1px',
              color: item.is_done ? theme.palette.case.neutral.n500 : theme.palette.case.neutral.n900,
              textDecorationLine: item.is_done ? 'line-through' : 'none',
            }}
            variant={'t14r'}
          >
            {item.sub_item}
          </Typography>
        </Box>
      </Link>
    );
  });

  return isLoading ? (
    <OnboardingItemsSkeleton />
  ) : (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%' }}>{renderItems}</Box>
  );
};
